enum HeightToggle {
	'propHeight' = 'propHeight',
	'full' = 'full',
	'1/3' = '1/3',
	'2/3' = '2/3',
}

export { HeightToggle };
